import React, { FC, useState, forwardRef, useEffect } from 'react';
import { Select, Spin } from 'antd';
import { MainReducerState } from '../../../store/reducers';
import { connect } from 'react-redux';
import {
    LibraryProgramTasksState,
    search as searchLibraryProgramTasks,
} from '../../../store/actions/libraryProgramTasks';
import { SelectProps } from 'antd/lib/select';
import { LibraryProgramTask } from '../../../store/api/apiTypes';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { LibraryProgramTaskListPayload } from '../../../store/api/libraryProgramTasks';
import { i18n } from '../../../helpers/i18n';

interface LibraryProgramTaskFilterSelectProps {
    onChange?: (value: any) => void;
    multi?: boolean;
    libraryProgramTasks: LibraryProgramTasksState;
    search: typeof searchLibraryProgramTasks.trigger;
    size?: SizeType;
    value ?: string[];
    setValue ?: any;
    initialValue ?: LibraryProgramTask[];
    filters ?: LibraryProgramTaskListPayload;
}

const LibraryProgramTaskFilterSelect: FC<LibraryProgramTaskFilterSelectProps> = forwardRef((props, ref: any) => {

    const {onChange, libraryProgramTasks, search, multi, size, filters} = props;
    const [ value, setValue ] = useState<any>();
    const [ initialValue, setInitialValue ] = useState<LibraryProgramTask[]>([]);

    useEffect(() => {
        if (props.initialValue) {
            setValue(props.initialValue.map((a) => a.id));
            setInitialValue(props.initialValue);
            if (onChange) { onChange(props.initialValue.map((a) => a.id || a)); }
        } else {
            setValue([]);
            setInitialValue([]);
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const onFocus: SelectProps<LibraryProgramTask['id']>['onFocus'] = () => {
        search({
            search: '',
            pageSize: 15,
            ...filters,
        });
    };

    const onSearch: SelectProps<LibraryProgramTask['id']>['onSearch'] = (newValue) => {
        search({
            search: newValue,
            pageSize: 15,
            ...filters,
            throttling: 250,
        });
    };

    const onChangeSelect: SelectProps<LibraryProgramTask['id']>['onChange'] = (newValue) => {
        setValue(newValue);
        if (onChange) {onChange(newValue); }
    };

    return (
        <Select
            mode={(multi) ? 'multiple' : undefined}
            size={size}
            ref={ref}
            showSearch
            value={value}
            placeholder="Recherchez une action"
            notFoundContent={libraryProgramTasks.search.loading ? <Spin size="small" /> : null}
            filterOption={false}
            onSearch={onSearch}
            onChange={onChangeSelect}
            onFocus={onFocus}
            allowClear
            style={{ width: '100%' }}
        >
            {
                [
                    ...initialValue, // Display initial value
                    ...libraryProgramTasks.search.data.items.filter((a) => !initialValue.map((b) => b.id).includes(a.id)), // Search items, excluding initial value
                ].map((libraryProgramTask) => (
                <Select.Option value={libraryProgramTask.id} key={libraryProgramTask.id}>{i18n(libraryProgramTask.name)}</Select.Option>
            ))}
        </Select>
    );

});

LibraryProgramTaskFilterSelect.defaultProps = {
    multi: false,
    size: 'small',
};

const mapStateToProps = (state: MainReducerState) => ({
    libraryProgramTasks: state.libraryProgramTasks,
});

export default connect(
    mapStateToProps,
    {
        search: searchLibraryProgramTasks.trigger,
    },
    null,
    { forwardRef: true },
)(LibraryProgramTaskFilterSelect);
